module Subscribe {
    declare var apiUrl: string;
    
    $(() => {

        $("#btnSubscribe").click(() => {

        });

        var siteDetailsByMeter = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: apiUrl + "OutageSubscription/GetsiteDetailsByMeter?hint=%QUERY"
            },
        });

        siteDetailsByMeter.initialize();

        $('#StreetAddress').typeahead(
            {
                hint: true,
                highlight: true,
                minLength: 3
            },
            {
            name: 'Street',
            displayKey: 'Street',
                source: siteDetailsByMeter.ttAdapter(),
                templates: {
                    empty: [
                        '<div class="empty-message">',
                        '<p>Haku ei löytänyt tuloksia</p>',
                        '</div>'
                    ].join('\n'),
                    suggestion: Handlebars.compile('<p><strong>{{Street}}</strong>, {{PostalCode}} {{PostalPlace}}</p>')

                }
            }).on('typeahead:selected', (obj, selected) => {
                console.log(obj);
                console.log(selected);
                $("#PostalCode").val(selected.PostalCode);
                $("#PostalPlace").val(selected.PostalPlace);
        });
    });
} 